import { useReducer } from 'react'
import {
  PEOPLE_1_TO_5,
  PEOPLE_6_TO_29,
  PEOPLE_30_TO_99,
  PEOPLE_100_TO_199,
  PEOPLE_200_PLUS
} from '../../constants/company-size'

type CompanyEmployees =
  | typeof PEOPLE_1_TO_5
  | typeof PEOPLE_6_TO_29
  | typeof PEOPLE_30_TO_99
  | typeof PEOPLE_100_TO_199
  | typeof PEOPLE_200_PLUS

interface SimulationAnswer {
  companyEmployees?: CompanyEmployees
  companyCity?: string
  companyCnpj?: string
  companyName?: string
  responsibleName?: string
  responsiblePhone?: string
  responsibleEmail?: string
  findOutAlice?: string
}

interface SimulationState {
  id: string
  answers: SimulationAnswer
  isReaccessingMESimulation: boolean
}

type SimulationAction =
  | { type: 'SET_ID'; payload: { id: string } }
  | { type: 'SET_ANSWER'; payload: SimulationAnswer }
  | { type: 'SET_IS_REACCESSING_ME_SIMULATION'; payload: boolean }
  | { type: 'RESET_ME' }
  | { type: 'RESET_RESPONSIBLE_PERSON' }
  | { type: 'RESET_COMPANY_DATA' }
  | { type: 'RESET' }

const useSimulationReducer = () => {
  const [simulation, simulationDispatch] = useReducer(
    simulationReducer,
    initialSimulationState
  )

  return {
    simulation,
    simulationDispatch
  }
}
const initialSimulationState: SimulationState = {
  id: '',
  answers: {},
  isReaccessingMESimulation: false
}

const simulationReducer = (
  state: SimulationState,
  action: SimulationAction
): SimulationState => {
  switch (action.type) {
    case 'SET_ID':
      return {
        ...state,
        ...action.payload
      }
    case 'SET_ANSWER':
      return {
        ...state,
        answers: {
          ...state.answers,
          ...action.payload
        }
      }
    case 'SET_IS_REACCESSING_ME_SIMULATION':
      return {
        ...state,
        isReaccessingMESimulation: action.payload
      }
    case 'RESET_ME':
      return {
        ...state,
        answers: {
          ...state.answers,
          companyCity: undefined,
          companyCnpj: undefined,
          responsibleName: undefined,
          responsiblePhone: undefined,
          responsibleEmail: undefined
        }
      }
    case 'RESET_RESPONSIBLE_PERSON':
      return {
        ...state,
        answers: {
          ...state.answers,
          responsibleName: undefined,
          responsiblePhone: undefined,
          responsibleEmail: undefined,
          findOutAlice: undefined
        }
      }
    case 'RESET_COMPANY_DATA':
      return {
        ...state,
        answers: {
          ...state.answers,
          companyCity: undefined,
          companyCnpj: undefined,
          companyName: undefined
        }
      }
    case 'RESET':
      return {
        ...state,
        id: '',
        answers: {},
        isReaccessingMESimulation: false
      }
    default:
      return state
  }
}

export { useSimulationReducer }
export type {
  SimulationState,
  SimulationAction,
  SimulationAnswer,
  CompanyEmployees
}
